function msStripSyncBars(track) {
  const strip = track.closest('.ms-strip');
  if (!strip) {
    return;
  }
  const bars = strip.querySelectorAll('[data-ms-bar]');
  const activeIndex = track.scrollLeft > track.offsetWidth / 2 ? 1 : 0;
  bars.forEach((bar, i) => bar.classList.toggle('ms-strip__bar--active', i === activeIndex));
}

document.addEventListener(
  'scroll',
  function (event) {
    if (!event.target?.hasAttribute?.('data-ms-track')) {
      return;
    }
    msStripSyncBars(event.target);
  },
  { passive: true, capture: true }
);

const MOUSE_DRAG_THRESHOLD_PX = 10;
const TAP_MAX_PX = 5;
/** Touch ended with vertical-dominant movement — likely page scroll; suppress synthetic click → product. */
const TOUCH_VERTICAL_DOMINANCE_MIN_PX = 8;
let lastStripNavigateAt = 0;
let lastTrackScrollAt = 0;
let msStripTouchActiveTrack = null;
let msStripTouchOrigin = null;

document.addEventListener(
  'scroll',
  function (event) {
    if (event.target && event.target.hasAttribute && event.target.hasAttribute('data-ms-track')) {
      lastTrackScrollAt = Date.now();
    }
  },
  { passive: true, capture: true }
);

document.addEventListener(
  'touchstart',
  function (event) {
    if (event.touches.length > 1) {
      msStripTouchActiveTrack = null;
      msStripTouchOrigin = null;
      return;
    }
    const track = event.target.closest('[data-ms-track]');
    if (!track) {
      return;
    }
    const t = event.touches[0];
    msStripTouchActiveTrack = track;
    msStripTouchOrigin = { x: t.clientX, y: t.clientY };
  },
  { capture: true, passive: true }
);

document.addEventListener(
  'touchcancel',
  function () {
    msStripTouchActiveTrack = null;
    msStripTouchOrigin = null;
  },
  { capture: true, passive: true }
);

document.addEventListener(
  'touchend',
  function (event) {
    if (!msStripTouchActiveTrack || !msStripTouchOrigin) {
      return;
    }
    const t = event.changedTouches[0];
    const dx = t.clientX - msStripTouchOrigin.x;
    const dy = t.clientY - msStripTouchOrigin.y;
    const track = msStripTouchActiveTrack;
    msStripTouchActiveTrack = null;
    msStripTouchOrigin = null;
    if (
      Math.abs(dy) > Math.abs(dx) &&
      Math.abs(dy) > TOUCH_VERTICAL_DOMINANCE_MIN_PX
    ) {
      track.dataset.msStripSuppressNextClick = '1';
    }
  },
  { capture: true, passive: true }
);

function msStripNavigateIfTap(track, strip, dx, dy, scrollDelta) {
  const url = strip && strip.dataset && strip.dataset.msProductUrl;
  if (!url) {
    return;
  }
  if (Math.abs(dx) > TAP_MAX_PX || Math.abs(dy) > TAP_MAX_PX) {
    return;
  }
  if (Math.abs(scrollDelta) > TAP_MAX_PX) {
    return;
  }
  lastStripNavigateAt = Date.now();
  window.location.assign(url);
}

/* Mouse: drag to scroll; tiny movement = tap → product page */
document.addEventListener(
  'pointerdown',
  function (event) {
    if (event.button !== 0) {
      return;
    }
    const track = event.target.closest('[data-ms-track]');
    if (!track) {
      return;
    }

    const w = track.offsetWidth;
    if (w <= 0) {
      return;
    }

    if (event.pointerType !== 'mouse') {
      return;
    }

    const strip = track.closest('.ms-strip');
    const startX = event.clientX;
    const startY = event.clientY;
    const startScrollLeft = track.scrollLeft;
    const startSlide = startScrollLeft < w / 2 ? 0 : 1;

    let dragged = false;
    track.classList.add('ms-strip__track--dragging');

    function onMove(e) {
      if (Math.abs(e.clientX - startX) > TAP_MAX_PX || Math.abs(e.clientY - startY) > TAP_MAX_PX) {
        dragged = true;
      }
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      let next = startScrollLeft - (e.clientX - startX);
      if (next < 0) {
        next = 0;
      } else if (next > maxScroll) {
        next = maxScroll;
      }
      track.scrollLeft = next;
    }

    function onUp(e) {
      track.classList.remove('ms-strip__track--dragging');
      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onUp);
      document.removeEventListener('pointercancel', onUp);

      const dx = e.clientX - startX;
      const dy = e.clientY - startY;
      const scrollDeltaBeforeSnap = track.scrollLeft - startScrollLeft;

      let targetLeft;
      if (startSlide === 0) {
        targetLeft = dx < -MOUSE_DRAG_THRESHOLD_PX ? w : 0;
      } else {
        targetLeft = dx > MOUSE_DRAG_THRESHOLD_PX ? 0 : w;
      }

      const prefersReduced =
        typeof window.matchMedia === 'function' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({
        left: targetLeft,
        behavior: prefersReduced ? 'auto' : 'smooth',
      });

      if (dragged) {
        track.dataset.msStripHadDrag = '1';
      } else {
        msStripNavigateIfTap(track, strip, dx, dy, scrollDeltaBeforeSnap);
      }
    }

    document.addEventListener('pointermove', onMove);
    document.addEventListener('pointerup', onUp);
    document.addEventListener('pointercancel', onUp);
  },
  { capture: true }
);

/* Touch / fallback: tap on track when no recent scroll (covers touch where we don’t handle pointerdown) */
document.addEventListener(
  'click',
  function (event) {
    const track = event.target.closest('[data-ms-track]');
    if (!track) {
      return;
    }
    if (track.dataset.msStripHadDrag) {
      delete track.dataset.msStripHadDrag;
      return;
    }
    if (track.dataset.msStripSuppressNextClick) {
      delete track.dataset.msStripSuppressNextClick;
      return;
    }
    if (event.detail !== 1) {
      return;
    }
    if (Date.now() - lastStripNavigateAt < 600) {
      return;
    }
    if (Date.now() - lastTrackScrollAt < 400) {
      return;
    }
    const strip = track.closest('.ms-strip');
    const url = strip && strip.dataset && strip.dataset.msProductUrl;
    if (!url) {
      return;
    }
    lastStripNavigateAt = Date.now();
    window.location.assign(url);
  },
  true
);
